// extracted by mini-css-extract-plugin
export var createdDate = "_g0-1";
export var divider = "_g0-2";
export var headerDivider = "_g0-3";
export var messagesCard = "_g0-0";
export var messagesContainer = "_g0-7";
export var messagesContainerWrapper = "_g0-4";
export var pointerCapturingButtonBoxes = "_g0-a";
export var showLeftPanelButton = "_g0-9";
export var showMoreButton = "_g0-c";
export var showMoreButtonContainer = "_g0-b";
export var summaryTitle = "_g0-6";
export var systemMessageCardWrapper = "_g0-d";
export var topButtons = "_g0-8";
export var withPadding = "_g0-5";